import React from 'react';
import { Create, SimpleForm, TextInput, useNotify, Toolbar, ListButton, SaveButton } from 'react-admin';

import { ContentWriterKeywordStatusSelectInput } from '../../UI/Input/SelectInput'
import { onContentWriterKeywordCreate } from '../../Service/Validation/ContentWriterKeywordValidation'
import Grid from '@material-ui/core/Grid';

const PageTitle = () => {
    return <span>Create content writer keyword</span>;
};

const FormToolbar = props => (
    <Toolbar {...props} >
        <SaveButton label="Save" redirect="show" submitOnEnter={true} />
        {!props.saving && <ListButton label="Cancel" />}
    </Toolbar>
)
const SanitizedGrid = ({ basePath, ...props }) => {
    return (
        <Grid {...props} />
    );
};

const ContentWriterKeywordCreate = (props) => {
    const notify = useNotify();

    const onError = (error) => {
        var errorArr = [];
        Object.keys(error.body.errors).forEach(function (key) {
            errorArr.push(error.body.errors[key])
        });
        notify(`Could not create item: ${errorArr.toString()}`, { type: 'error' });
    };
    return (
        <Create title={<PageTitle />} {...props} undoable={false} mutationOptions={{ onError }}>
            <SimpleForm toolbar={<FormToolbar />} warnWhenUnsavedChanges validate={onContentWriterKeywordCreate}>
                <SanitizedGrid container spacing={3} fullWidth>
                    <Grid item sm={12} md={4} lg={4}>
                        <TextInput label="Keyword" source="keyword" fullWidth />
                    </Grid>
                    <Grid item sm={12} md={4} lg={4}>
                        <ContentWriterKeywordStatusSelectInput label="Status" source="status" fullWidth />
                    </Grid>
                </SanitizedGrid>
            </SimpleForm>
        </Create>
    );
}
export default ContentWriterKeywordCreate